import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'

export const SectionWrapper = styled.div`
  padding: 0 30px;
  ${Media.desktop`
    margin-top: 15px;
    box-shadow: 0px 0px 10px rgba(113, 113, 113, 0.349);
  `}
  ${Media.mobile`
    padding: 0 10px;
  `}

  [data-section] {
    border-bottom: unset;
  }

  [data-at-quickappointment-calendar] {
    margin-bottom: 0;
  }
`

export const ErrorMessage = styled.div`
  margin: 20px 0;
  color: red;
  ${Mixin.font.GothamBold()}
  ${Media.desktop`
    ${props => props.alignRight && css`
      text-align: right;
    `}
  `}
  ${Media.mobile`
    text-align: center;
  `}
`

export const ActionBarWrapper = styled.div`
  padding: ${props => props.condensedBottom ? '10px 0' : '18px 0'};
`
